:host {
  display: block;
}

lgr-slide {
  padding: 32px;
  box-sizing: border-box;

  .container-background {
    padding: 16px;
    border-radius: 16px;
    background-color: #ED9539;
  }
}
